
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"29","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 28.387v-28h28v28z"}}),_c('path',{attrs:{"d":"M14 19.055l8.587-6.685 1.913-1.48L14 2.722 3.5 10.889l1.902 1.481L14 19.055zm-.012 2.964L5.39 15.334l-1.89 1.47L14 24.97l10.5-8.166-1.902-1.482-8.61 6.697z","fill":"#FFF"}})])])
          )
        }
      }
    